import {
  ArticleCount,
  Category,
  Subcategory,
  CategorySelectorRow
} from "@/services/CategoriesDataService";
import { LineGraphData } from "@/components/LineGraph.vue";

export const isSubcategory = (
  category: Category | Subcategory
): category is Subcategory => {
  return (category as Subcategory).parentId !== undefined;
};

export const categoriesEqual = (first: Category, second: Category): boolean => {
  return first.id == second.id;
};

export const subcategoriesEqual = (
  first: Subcategory,
  second: Subcategory
): boolean => {
  return first.id == second.id && first.parentId == second.parentId;
};

export const generateGraphData = (
  articleCounts: ArticleCount[] | null,
  category: CategorySelectorRow | null,
  maxYear: number
): LineGraphData[] => {
  if (articleCounts === null) {
    return [];
  }
  const categoryObject: Category | null = category
    ? {
        id: category.section_letter,
        field: category.section_heading
      }
    : null;
  const graphData = [
    {
      id: "1",
      color: "#89d2f0",
      category: categoryObject,
      title: category ? category.section_heading : "...",
      data: articleCounts
        .filter(
          count =>
            count.publication_year <= maxYear &&
            !Number.isNaN(count.publication_year) &&
            count.publication_year > 0
        )
        .map(count => ({
          date: count.publication_year,
          value: count.article_count
        }))
    }
  ];
  const invalidCounts = articleCounts.length - graphData[0].data.length;
  if (invalidCounts) {
    console.warn(`Number of invalid article counts: ${invalidCounts}`);
  }
  return graphData;
};
